module.exports = __webpack_public_path__ + "img/tidal.1b79f8ef.svg";